import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
const Send = _ref => {
  let {
    color = '#788590',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"
  }));
};
export default /*#__PURE__*/React.memo(Send);